import React, { useState } from "react";
import { PageHeader } from "@shared/components/PageHeader";
import { Card } from "@shared/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/ui/select";
import { Button } from "@shared/ui/button";
import KpiPerformanceDashboard from "./dashboard";
import { OverviewDetails } from "./overview";
import { MeterReadingQuality } from "./meterReadingQuality";
import { HistoricalPerformance } from "./historicalPerformanace";
import { useParams } from "react-router-dom";
import { useGetMeterRunHistory, useGetPerformanceDashboard } from "@features/mx/readCycleManagement/hooks";

export default function PerformanceTab() {
  const { cycle_id } = useParams();
  const [period, setPeriod] = useState("");
  const { data: meterRunHistory } = useGetMeterRunHistory(cycle_id);
  const { data: performanceDashboard } = useGetPerformanceDashboard(cycle_id,Number(period));

  const handlePeriodSelect = (value) => {
    setPeriod(value);
  };

  const handleClear = () => {
    setPeriod("");
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <PageHeader
          title="Performance"
          subtitle="Cycle-level KPIs, data quality, and historical trends for the current reading period."
        />

        <div className="mt-4 flex flex-col sm:flex-row sm:items-end sm:justify-end gap-3">
          <div className="flex flex-col">
            <Select value={period} onValueChange={handlePeriodSelect}>
              <SelectTrigger
                id="reading-period"
                className="w-full sm:w-[300px]"
              >
                <SelectValue placeholder="Select period" />
              </SelectTrigger>
              <SelectContent>
                {meterRunHistory?.results?.map((period) => (
                  <SelectItem key={period.id} value={period.id}>
                    {period.month} — {period.startDate} - {period.endDate}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="outline" onClick={handleClear} className="ml-2">
              Clear
            </Button>
          </div>
        </div>
      </div>

      <Card className="mt-6">
        <KpiPerformanceDashboard data={performanceDashboard} />
        <div className="mt-6">
          <OverviewDetails data={performanceDashboard} />
        </div>
        <div className="mt-6">
          <MeterReadingQuality data={performanceDashboard} />
        </div>
      </Card>

      <Card className="mt-6">
        <HistoricalPerformance data={performanceDashboard} />
      </Card>
    </div>
  );
}
